import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

export const useInViewPort = <T extends HTMLElement>(
    ref: RefObject<T>,
    checkIntersectionVisibility: boolean,
    options?: IntersectionObserverInit,
): boolean => {
    const [isInView, setIsInView] = useState(() => !checkIntersectionVisibility);

    useEffect(() => {
        const element = ref.current;

        if (!element) {
            return undefined;
        }

        const observer = new IntersectionObserver(([entry]) => setIsInView(entry.isIntersecting), {
            root: null,
            rootMargin: '0px',
            threshold: 0.5,
            ...options,
        });

        if (checkIntersectionVisibility) {
            observer.observe(element);
        }

        return () => {
            observer.unobserve(element);
        };
    }, [checkIntersectionVisibility, options, ref]);

    return isInView;
};
